import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import { ellipsis } from 'polished';
import styled from 'styled-components';
import { color, typography } from 'styled-system';
import { Box } from '../grid/Grid';
var StyledHeading = styled(Box)(_templateObject(), color, typography, function (props) {
  return props.isTruncated && ellipsis();
});
export var Heading =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var _ref$m = _ref.m,
      m = _ref$m === void 0 ? 0 : _ref$m,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'blacks.0' : _ref$color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? '36px' : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 500 : _ref$fontWeight,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 1.5 : _ref$lineHeight,
      props = _objectWithoutProperties(_ref, ["m", "color", "fontSize", "fontWeight", "lineHeight"]);

  return (
    /*#__PURE__*/
    React.createElement(StyledHeading, _extends({
      ref: ref,
      as: "h1",
      m: m,
      color: color,
      fontSize: fontSize,
      fontWeight: fontWeight,
      lineHeight: lineHeight
    }, props))
  );
});
Heading.displayName = 'Heading';